import { PaymentTypeE } from "components/Pages/Purchases_new/models/enums";
import apiRequest from "utils/ApiRequest/apiRequest";

export type TransactionDataT = {
  TransactionEmail: string | undefined;
  TransactionFirstName: string | undefined;
  TransactionLastName: string | undefined;
  TransactionPhone: string | undefined;
  TransactionCountryId: number;
  TransactionPriceDisplayedToUser: number;
  TransactionPurchaseProvider: PaymentTypeE | undefined;
  TransactionPurchaseType: string;
  TransactionUserIsAuthenticated: boolean;
  TransactionCurrency: string;
  getOnlyIframe: boolean;
  TransactionPackageName: string;
  TransactionUserPassword: string;
};

const fetchPaymentUrl = async (transactionData: TransactionDataT) => {
  try {
    const response = await apiRequest(
      "Transactions",
      "ClientCheckoutSubmitReact",
      transactionData,
      "POST"
    );

    if (response.data) {
      const paymentUrl = response.data.PaymentPageUrl;
      return paymentUrl;
    }
  } catch (error) {
    console.error(error);
  } finally {
  }
};

export default fetchPaymentUrl;
